module.exports = __webpack_public_path__ + "img/logo_light.338e5429.png";